import React from 'react';
import styled from 'styled-components';
import CustomLabel from '../label/CustomLabel';
import NormalBtn from '../button/NormalBtn';
import IconBtn from '../button/IconBtn';
import CustomTitle from '../title/CustomTitle';

/**
 * Modal 팝업 안에 들어가는 일반 팝업 
 */
const NormalPopupBlock = styled.div` 
    min-width: 330px;
    height: 100%;
    border-radius: 10px;
`;

const NormalPopupContentsBlock = styled.div`
    width: 100%;
    height: auto;
    background-color:#fff;
    border-radius: 10px;
    padding: 30px;
`;

// const NormalPopupCloseIconBlock = styled.img`
//     display: ${props => props.display || 'none'};
//     position: absolute;
//     top: 50px;
//     right: 15px;
//     width: 30px;
//     height: 30px;
//     cursor: pointer;
//     src:${(props) => (props.src)};
// `;

const NormalPopupTitleContainerBlock = styled.div`
    //margin: 0 auto;
    text-align: center;
    //height: '50%';
    //width: '90%';
    margin-top: 6px;
    margin-bottom: 6px;
`;

const NormalPopupBtnContainerBlock = styled.div`
    margin: 0 auto;
    text-align: center;
    //float: ${props => props.float || 'left'};
    vertical-align: top;
    margin-top: 30px;
    //height : 40px;
    width: intrinsic;           /* Safari/WebKit uses a non-standard name */
    width: -moz-max-content;    /* Firefox/Gecko */
    width: -webkit-max-content; /* Chrome */
    width: max-content;
`;

const NormalPopupCenterBtnContainerBlock = styled.div`
    margin: 0 auto;
    text-align: center;
    //float: ${props => props.float || 'left'};
    vertical-align: top;
    margin-top: 30px;
`;

const NormalPopupBtnBlock = styled.div`
    min-width: 110px;
    height: 40px;
    display: inline-block;
    float: ${props => props.float || 'left'}; //left;
    margin-top: ${props => props.marginTop || '10px'};
    margin-right: ${props => props.marginRight || '0px'};
    margin-left: ${props => props.marginLeft || '0px'};
`

const NormalPopupCenterBtnBlock = styled.div`
    min-width: 110px;
    height: 40px;
    //display: inline-block;
    float: ${props => props.float || 'left'}; //left;
    margin-top: ${props => props.marginTop || '10px'};
    margin-right: ${props => props.marginRight || '0px'};
    margin-left: ${props => props.marginLeft || '0px'};
`

export const customModalStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '10%',
        transform: 'translate(-50%, -50%)',
        zIndex: '999',
        overlay: 'auto',
        WebkitOverflowScrolling: 'touch',
        minWidth: "350px",
        height: "auto",
        borderRadius: '0px',
        backgroundColor: 'transparent',
        borderWidth: '0px',
    },
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        zIndex: '1000'
    },
};

const NormalPopup = ({ text, text2, text3, btn1, btn2,
    onClick1, onClick2, fontWeight = 500, fontWeight2 = 500, fontWeight3 = 500 , centerBtn = false}) => {
    return (
        <NormalPopupBlock>
            <NormalPopupContentsBlock>

                <NormalPopupTitleContainerBlock >

                    <CustomTitle
                        title={text} textColor="#333"
                        fontSize="16px" fontWeight={fontWeight}
                        marginTop="10px" textAlign="center"
                        marginBottom="10px"
                        lineHeight="24px"
                        display={(text !== null && text !== undefined && text.length > 0) ? "block" : "none"} />
                    <CustomTitle
                        title={text2} textColor="#333"
                        fontSize="16px" fontWeight={fontWeight2}
                        marginTop="10px" textAlign="center"
                        marginBottom="10px"
                        lineHeight="24px"
                        display={(text !== null && text2 !== undefined && text2.length > 0) ? "block" : "none"} />
                    <CustomTitle
                        title={text3} textColor="#333"
                        fontSize="16px" fontWeight={fontWeight3}
                        marginTop="10px" textAlign="center"
                        marginBottom="10px"
                        lineHeight="24px"
                        display={(text !== null && text3 !== undefined && text3.length > 0) ? "block" : "none"} />
                </NormalPopupTitleContainerBlock>
                {
                    centerBtn?
                    <NormalPopupCenterBtnContainerBlock className="clearfix">
                        <NormalPopupCenterBtnBlock className="clearfix" float='none' marginRight='0px' marginLeft='0px' marginTop="0px">
                            <NormalBtn text={btn1}
                                minWidth="110px" height="40px" width='100%'
                                fontSize="16x" display="inline-block"
                                borderRadius="20px" 
                                onClick={onClick1} bgColor="#111" fontWeight="400"
                                marginTop='0px'
                                padding='0 30px'
                            />
                        </NormalPopupCenterBtnBlock>

                        <NormalPopupCenterBtnBlock className="clearfix" float='none' marginRight='0px' marginLeft='0px' marginTop="10px">
                            <NormalBtn text={btn2} 
                                minWidth="110px" height="40px" width='100%'
                                borderRadius="20px" fontWeight="400"
                                float="left" fontSize="16px" bgColor="#ccc" textColor="#111"
                                display="inline-block" onClick={onClick2}
                                marginTop='0px' 
                                padding='0 30px'/>
                        </NormalPopupCenterBtnBlock>
                    </NormalPopupCenterBtnContainerBlock>
                    :
                    <NormalPopupBtnContainerBlock className="clearfix">
                        <NormalPopupBtnBlock className="clearfix" marginRight='0px' marginLeft='10px' marginTop="0px">
                            <NormalBtn text={btn1}
                                minWidth="110px" height="40px" width='auto'
                                fontSize="16x" display="inline-block"
                                borderRadius="20px" textColor="#111"
                                onClick={onClick1} bgColor="#ccc" fontWeight="400"
                                marginTop='0px'
                                padding='0 30px'
                            />
                        </NormalPopupBtnBlock>

                        <NormalPopupBtnBlock className="clearfix" float='left' marginRight='10px' marginLeft='30px' marginTop="0px">
                            <NormalBtn text={btn2} minWidth="110px" height="40px" width='auto'
                                borderRadius="20px" fontWeight="400"
                                float="left" fontSize="16px" bgColor="#111"
                                display="inline-block" onClick={onClick2}
                                marginTop='0px' 
                                padding='0 30px'/>
                        </NormalPopupBtnBlock>
                    </NormalPopupBtnContainerBlock>
                }
                

            </NormalPopupContentsBlock>

        </NormalPopupBlock>
    );
};

export default NormalPopup;